import { Advantages } from '../components/home/Advantages';
import { Hero } from '../components/home/Hero';
import { PopularList } from '../components/home/PopularList';
import { Quote } from '../components/home/Quote';
import { Ticker } from '../components/home/Ticker';

export function HomePage() {
  return (
    <>
      <Hero />
      <Ticker />
      <Advantages />
      <Quote />
      <PopularList />
    </>
  );
}
